import React from 'react';
import { styled, Col, Button, Row, Currency } from '@teko/ui';
import background from './assets/combined-shape.es.js';
import { getTrackingData } from '@teko/tracking';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const CouponWrapper = styled.div`
  display: flex;
  flex-direction: row;
  background-image: url('${background}');
  background-size: contain;
  background-repeat: no-repeat;
`;
const StyledCol = styled(Col)`
  margin-top: 10px;
  padding: 0px;
  text-align: right;
  color: #ef2741;
  font-weight: 500;
  span {
    margin-right: -6px;
  }
`;
const StyledButton = styled(Button)`
  padding-left: 0px;
`;
const CloseButton = styled(Button)`
  padding-right: 0px;
  padding-top: 8px;
  padding-left: 6px;
`;
const AppliedCoupon = (_a) => {
  var _b = _a, {
    text,
    discount,
    type,
    action,
    isCloseHidden = false
  } = _b, props = __objRest(_b, [
    "text",
    "discount",
    "type",
    "action",
    "isCloseHidden"
  ]);
  const onRemoveClicked = () => {
    if (action)
      action();
  };
  return /* @__PURE__ */ React.createElement(CouponWrapper, __spreadValues({}, props), /* @__PURE__ */ React.createElement(Col, {
    col: 6
  }, /* @__PURE__ */ React.createElement(StyledButton, {
    link: true,
    disabled: true,
    icon: {
      name: type == "coupon" ? "percentage" : "tag",
      size: 25
    }
  }, text)), /* @__PURE__ */ React.createElement(Col, {
    col: 6
  }, /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(StyledCol, {
    col: 8
  }, "-", /* @__PURE__ */ React.createElement(Currency, {
    value: discount
  })), !isCloseHidden && /* @__PURE__ */ React.createElement(Col, __spreadValues({
    col: 4
  }, getTrackingData({
    isTrackContent: true,
    regionName: "couponSection",
    contentName: "removeCoupon"
  })), /* @__PURE__ */ React.createElement(CloseButton, {
    link: true,
    icon: { name: "circle-close", size: 20, color: "#e0e0e0" },
    onClick: onRemoveClicked
  })))));
};

export { AppliedCoupon };
